import {initGoogleMap} from './scripts/google-map';

const $ = jQuery;

$(() => {
    initCommonFunctions()
    initGoogleMap()
})

function initCommonFunctions() {
    $.each($('textarea.cf-item__input'), function() {
        var offset = this.offsetHeight - this.clientHeight;

        var resizeTextarea = function(el) {
            $(el).css('height', 'auto').css('height', el.scrollHeight + offset);
        };
        $(this).on('keyup input', function() { resizeTextarea(this); });
    });

    //slick slider
    $(document).ready(function() {
        $('.rd-slider').slick({
            arrows: false,
            dots: true,
        });
    });

    // sticky header
    if ($(window).scrollTop() > 100) {
        $('.site-header').addClass('shrink');
    }
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.site-header').addClass('shrink');
        } else {
            $('.site-header').removeClass('shrink');
        }
    });

    //menu toggle
    $('.toggle').click(function() {
        $('.toggle').toggleClass('cross');
        $('.menu__container').toggleClass('shown');
    });

    //submenu toggle
    if ($('.menu-item-has-children').length) {

        $('.menu-item-has-children > a').on('click', function(e) {
            e.preventDefault();
            $(this).parent('.menu-item-has-children').toggleClass('opened');
        });

        $('.site-content').on('click', function(e) {
            $('.menu-item-has-children').removeClass('opened');
        });
    }

    // modal window
    $('.show-modal').on('click', function() {
        $('body').addClass('modal-shown');
        $('html').addClass('modal-shown');
        $('.body-cover').addClass('shown');
        $('.modal-form.modal-form--global').addClass('shown');
    });
    $('.body-cover').on('click', function() {
        $('body').removeClass('modal-shown');
        $('html').removeClass('modal-shown');
        $('.body-cover').removeClass('shown');
        $('.modal-form').removeClass('shown');
    });
    $('.modal-form__close').on('click', function(e) {
        e.preventDefault();
        $('body').removeClass('modal-shown');
        $('html').removeClass('modal-shown');
        $('.body-cover').removeClass('shown');
        $('.modal-form').removeClass('shown');
    });

    // modal form for content block
    $('.show-form').on('click', function() {
        var contactForm = $(this).next().find('.modal-form--contact');

        $('body').addClass('modal-shown');
        $('html').addClass('modal-shown');
        $('.body-cover').addClass('shown');
        contactForm.addClass('shown');

    });

    // acf google map cover
    $('.rd-map__cover').on('click', function() {
        $(this).css('display', 'none');
    });

    // contact form 7
    $('.cf-item__input').each(function() {
        $(this)[0].addEventListener('focus', function() {
            $(this).closest('.cf-item').addClass('active');
        });
        $(this)[0].addEventListener('blur', function() {
            if (!$(this).val()) {
                $(this).closest('.cf-item').removeClass('active');
            }
        });
    });

    $('.wpcf7').on('wpcf7mailsent', function () {
        $(this).find('.cf-item').removeClass('active')
    })
}
